var _circle, _path, _circle2, _path2, _circle3, _path3, _circle4, _path4, _circle5, _path5, _circle6, _path6, _circle7, _path7, _circle8, _path8, _circle9, _path9, _circle10, _path10, _circle11, _path11, _circle12, _path12, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAbacusFrance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.197,
    cy: 19.736,
    r: 2.724,
    fill: "#002852"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001a35",
    d: "M21.276 17.057a2.72 2.72 0 01-3.758 3.76 2.722 2.722 0 103.758-3.76z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.834,
    cy: 19.736,
    r: 2.724,
    fill: "#002852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#001a35",
    d: "M31.914 17.057a2.72 2.72 0 01-3.759 3.76 2.722 2.722 0 103.759-3.76z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.697,
    cy: 19.736,
    r: 2.724,
    fill: "#002852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#001a35",
    d: "M38.777 17.057a2.72 2.72 0 01-3.76 3.76 2.722 2.722 0 103.76-3.76z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.246,
    cy: 19.736,
    r: 2.724,
    fill: "#002852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#001a35",
    d: "M46.326 17.057a2.72 2.72 0 01-3.76 3.76 2.722 2.722 0 103.76-3.76z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.931,
    cy: 30.374,
    r: 2.724,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1b1b1",
    d: "M25.01 27.695a2.72 2.72 0 01-3.758 3.758 2.722 2.722 0 103.759-3.758z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.137,
    cy: 30.374,
    r: 2.724,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1b1b1",
    d: "M32.217 27.695a2.72 2.72 0 01-3.76 3.758 2.722 2.722 0 103.76-3.758z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.264,
    cy: 30.374,
    r: 2.724,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1b1b1",
    d: "M48.344 27.695a2.72 2.72 0 01-3.759 3.758 2.722 2.722 0 103.76-3.758z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.814,
    cy: 30.374,
    r: 2.724,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1b1b1",
    d: "M55.893 27.695a2.72 2.72 0 01-3.759 3.758 2.722 2.722 0 103.76-3.758z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.931,
    cy: 41.011,
    r: 2.724,
    fill: "#d8062b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#a40c27",
    d: "M25.01 38.332a2.72 2.72 0 01-3.758 3.759 2.722 2.722 0 103.759-3.759z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.137,
    cy: 41.011,
    r: 2.724,
    fill: "#d8062b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#a40c27",
    d: "M32.217 38.332a2.72 2.72 0 01-3.76 3.759 2.722 2.722 0 103.76-3.759z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.088,
    cy: 41.011,
    r: 2.724,
    fill: "#d8062b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#a40c27",
    d: "M42.168 38.332a2.72 2.72 0 01-3.76 3.759 2.722 2.722 0 103.76-3.759z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.423,
    cy: 41.011,
    r: 2.724,
    fill: "#d8062b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#a40c27",
    d: "M52.502 38.332a2.72 2.72 0 01-3.759 3.759 2.722 2.722 0 103.76-3.759z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.092 58.874v-46M48.651 19.737l10.895-.001M41.023 19.737h.869M34.144 19.737h.263M23.586 19.737h3.887M12.859 19.737h4.032M59.908 58.874v-46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.197,
    cy: 19.736,
    strokeMiterlimit: 10,
    strokeWidth: 1.362,
    r: 2.724
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.834,
    cy: 19.736,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.697,
    cy: 19.736,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.246,
    cy: 19.736,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M58.075 30.374h.784M50.557 30.374h.985M34.48 30.374h9.442M27.183 30.374h.702M12.859 30.374h7.775"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.931,
    cy: 30.374,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.137,
    cy: 30.374,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.264,
    cy: 30.374,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.814,
    cy: 30.374,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M54.76 41.011h4.099M44.44 41.011h3.631M34.458 41.011h3.333M27.252 41.011h.56M12.859 41.011h7.747"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.931,
    cy: 41.011,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.137,
    cy: 41.011,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.088,
    cy: 41.011,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.423,
    cy: 41.011,
    r: 2.724,
    strokeMiterlimit: 10,
    strokeWidth: 1.362
  }))));
}

export default SvgAbacusFrance;